
<div class="trinka_cloud_wrap">
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>문법 검사기 API</h1>
                        <h2>간단하고 빠른 AI 문법 검사 API</h2>
                        <p>AI에 기반한 트링카 문법 검사는 간단한 RESTful API를 통해 제공되어 애플리케이션 내에서 강력한 실시간 또는 수동 문법 검사를<br class="d-none d-lg-block"/> 바로 수행합니다.</p>
                        <button type="button" data-toggle="modal" data-target="#EnterPriseContactPopup" class="plansButtons">문의하기</button>
                        <a href="#sampleCode"  data-toggle="modal" data-target="#sampleCode" id="autoEditGetStart" class="cta-outline-btn m25">샘플 코드</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img text-center" style="text-align: center !important;">
                        <img src="../../../assets/images/trinka-api.svg" alt="Grammar Check API">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section mt-40">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="most_united_heading">
                    <h2>
                        <span></span>Power Bespoke 애플리케이션에 고유 통합</h2>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="most_suited_point">
                    <ul>
                        <li>콘텐츠 관리 시스템</li>
                        <li>온라인 글쓰기 플랫폼</li>
                        <li>메시징 앱/소셜 플랫폼</li>
                        <li>CRM + 헬프데스크 소프트웨어</li>
                        <li>클라이언트 이메일</li>
                        <li>프로젝트 관리 소프트웨어</li>
                        <li>E-러닝 플랫폼</li>
                        <li>학습 관리 시스템</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="cloud_key_features cloudKeyBenefitSection mb-0 bg-white">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading mb-0">
                    <h2>텍스트 또는 파일 - 트링카 API로 선택 가능</h2>
                    <div class="HeadingSubLine"></div>
                    <p class="mb-0">워크플로와 기술적 측면을 충족해 주는 트링카 문법 검사 API를 통해 막힘없이 매끄러운 통합을 구축해 보세요.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_left">
                        <h3>실시간 확인 API</h3>
                        <p>트링카의 실시간 검사는 학습 플랫폼, 편집기, 채팅 애플리케이션 등 그 <br class="d-lg-block d-none"/> 자리에서 즉각적인 글 수정이 필요한 애플리케이션을 강화해 드립니다.</p>
                        <ul>
                            <li>줄글, 단락 글, 또는 그보다 큰 텍스트 모음을 전달할 수 있는 유연성</li>
                            <li>모든 입력 형식에 대처할 수 있는 간단한 응답 페이로드</li>
                            <li>텍스트 양이나 API 호출 건수에 따른 유연한 지불 방식</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_right">
                        <img src="../../../assets/images/Real-time Check API.svg" alt="Real-time Check API" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections" style="padding-top: 0;">
        <div class="container">       
            <div class="row flex-row-reverse align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_left">
                        <h3>파일 편집 API</h3>
                        <p>트링카의 파일 편집 API를 사용하면 복잡한 통합 작업과 API 대량 호출 <br class="d-lg-block d-none"/> 없이도 고유한 워크플로 요구 사항을 지원할 수 있습니다.</p>
                        <ul>
                            <li>한 번의 API 호출로 편집된 파일 가져오기</li>
                            <li>변경 사항 추적을 통해 버전 관리 및 사용자정의 컨트롤</li>
                            <li>평가용 글쓰기 품질 점수 및 수정 사항 요약</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_right">
                        <img src="../../../assets/images/file-edit-api.png" alt="File-edit API" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="cloud_key_features cloudKeyBenefitSection mb-0 bg-light-purple">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading">
                    <h2>트링카 문법 검사기 API로 구동되는 고유한 사용 사례</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row match-box">

            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>E-러닝 애플리케이션</h3>
                    </div>
                    <p>지금까지 트링카 문법 검사기 API는 애플리케이션 개발자가 학계의 표준을 충족하도록 학습자의 작문을 다듬는 데 도움이 <br class="d-lg-block d-none"/> 되었습니다.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>출판 및 편집</h3>
                    </div>
                    <p>트링카의 문법 검사 API는 편집자에게 보조 텍스트 수정을 지원하여 시간과 품질 비용을 절약해 드립니다.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>학생 포럼</h3>
                    </div>
                    <p>트링카 문법 검사 API의 강력한 검사 기능은 포럼과 그룹에서 학생들의 효과적인 <br class="d-lg-block d-none"/> 의사소통을 도와 학생 참여도를 높여<br class="d-lg-block d-none"/>드립니다.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>기업</h3>
                    </div>
                    <p>지금까지 트링카의 문법 검사 API 덕분에 많은 팀들이 명확성, 일관성 또는 브랜드 <br class="d-lg-block d-none"/> 인지도를 희생하지 않고 더 나은 글을 작성<br class="d-lg-block d-none"/>할 수 있었습니다.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>생산성 플랫폼</h3>
                    </div>
                    <p>트링카의 실시간 API는 생산성 플랫폼이 <br class="d-lg-block d-none"/> 고유한 글쓰기 지원을 제공하여 사용자의 <br class="d-lg-block d-none"/> 생산성을 높이도록 도와드립니다.</p>
                </div>
            </div>

            <!-- <div class="col-lg-4 col-md-6">
                <div class="features_cards commingSoonTag">
                    <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="">
                    <h3>Subject Area & Document Type</h3>
                    <p>Customize Trinka to provide you the most relevant suggestions based on your subject area and
                        type of manuscript.</p>
                </div>
            </div> -->

        </div>
        
    </div>
</div>

<div class="use_trinka_other_app accomplishBrilliantWrap mt-0">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="accomplishBrilliantSection">
                    <h2>트링카 문법 검사기 API가 할 수 있는 일 확인</h2>
                    <a data-toggle="modal" data-target="#EnterPriseContactPopup" class="plansButtons pointer">문의하기</a>
                </div>
            </div>
        </div>
            
    </div>
</div>

<div class="cloud_key_features cloudKeyBenefitSection cs-section">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading mb-3">
                    <h2>간단한 API를 통해 트링카의 모든 기능에 액세스</h2>
                    <div class="HeadingSubLine"></div>
                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-5 col-xl-5">
                <div class="cs-left-section">
                    <p>트링카 문법 검사 API는 고급 영어 문법 교정에서 어조 및 스타일 향상에 이르기까지 포괄적인 글쓰기 지원을 제공합니다. 필요에 맞는 기능을 골라서 선택해 보세요!</p>
                    <p>트링카의 문법 및 맞춤법 검사 API는 학술적 글쓰기 규칙과 모범 사례에 맞게끔 글쓰기 방법을 개선하는 동시에 아이디어에 더 집중할 수 있도록 도와드립니다.</p>
                    <!-- <p>Trinka stands out by working with the author and going beyond grammar and spelling checks to ensure holistic language enhancement.</p> -->
                    <p>또한 트링카 문법 검사기 API는 기술적 표현, 학술적 어조, <br class="d-lg-block d-none"/> 편파적이지 않은 언어, 단어 선택, 용법과 스타일 등 추가 기능도 제공합니다.  </p>
                </div>
            </div>
            <div class="col-lg-7 col-xl-7">
                <div class="xs-features-api">
                    <span class="hline"></span>
                    <span class="vline"></span>
                    <span class="vline vline2"></span>
                    <div class="row match-box">
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Advanced-Grammar.png" alt="Advanced Grammar" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading ">
                                        <h3>고급 문법</h3>
                                    </div>
                                    <p>학계 및 공식 커뮤니케이션에 최적
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_ExpertProofreading.png" alt="Subject-specific Corrections" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>구체적 주제별 수정</h3>
                                    </div>
                                    <p>자동 주제 감지 및 정확한 수정 제안
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_title.png" alt="Contextual Spelling" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>맥락에 적합한 철자 표기</h3>
                                    </div>
                                    <p>주제에 따라 올바른 용어 선택
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_Pass_02.png" alt="Tips & Explanations" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>팁과 설명</h3>
                                    </div>
                                    <p>사용자를 위한 AI의 설명 가능한 수정 제안
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Non-standard-2.png" alt="Style Guide Preference" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>스타일 가이드 기본 설정 </h3>
                                    </div>
                                    <p>스타일 가이드(AMA, APA 등)를<br class=""/>기반으로 한 수정 제안
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media no-border-before">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_Dictionary.png" alt="Custom Dictionaries" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>맞춤 설정 사전</h3>
                                    </div>
                                    <p>제안 개선 및 브랜드 유지
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="pricing_works">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="brandlogo_heading">
                    <h2>나에게 가장 적합한 유연한 가격 책정</h2>
                </div>
                <p>트링카는 사용자와 협력하여 해당 사용자에게 최고의 가치를 제공하는 최고의 가격 측정 모델을 식별합니다. 요구 사항에 정확히 들어맞도록 텍스트 양, 파일 양, 또는 API <br class="d-lg-block d-none"/> 호출량에 기반한 가격 옵션을 지원해 드립니다.</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="writeToolboxs_section1">
    <div class="writeToolbox_inner_sections1">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>안전, 보안, 신뢰</h3>
                        <p>트링카는 데이터 보안과 개인 정보 보호를 최우선으로 생각합니다. 내 모든 데이터는 <br class="d-lg-block d-none"/> 강력하게 암호화되어 안전하게 저장됩니다. 다른 사람은 내 데이터에 액세스할 수 <br class="d-lg-block d-none"/> 없습니다.
                            <br>트링카는 글쓰기 제안을 받으면 데이터 저장을 제거하는 고유한 플랜을 제공해 드립니다.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe-secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections1 sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="ai" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>AI 소개</h3>
                        <p>트링카는 최신 머신러닝(ML) 및 자연어 처리(NLP) 기술을 사용하여 문법 오류를 식별하고 언어 향상을 제안합니다. 의학, 생명과학, 생물학, 물리학, 공학, 인문학, 비즈니스
                            및 예술을 포함한 1300개 이상의 주제 영역을 망라하며 모범적으로 작성된 논문 및 기사 <br class="d-lg-block d-none"/> 수백만 건을 바탕으로 훈련되기에 해당 주제에 가장 적절한 제안을 제공합니다.</p>
                        <p>트링카는 장벽 없는 커뮤니케이션을 통해 미래를 만들어가고자 하는 깊은 열망을 품은
                            <br>언어학자, 의학 에디터, 데이터 과학자 및 엔지니어로 이루어진 팀이 개발했습니다.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="pricingQuestionAnwser" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="pricingHeadingQuestion">
                    <h2>자주 하는 질문</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="pricingQuestionsList">
                    <div class="accordion" id="faq">
                        <div class="card">
                            <div class="card-header" id="QuestionOne">
                                <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                    문법 또는 맞춤법 검사 API는 누가 쓰면 좋을까요?</a>
                            </div>

                            <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                <div class="card-body">
                                    <p>트링카 문법 검사기 API는 다양한 용도로 사용 가능합니다. 트링카 클라이언트들은 현재 다음과 같은 경우에 API를 <br class="d-lg-block d-none"/> 사용하고 있습니다.</p>
                                    <ol>
                                        <li>에세이 자동 마킹.</li>
                                        <li>애플리케이션의 텍스트 편집기에 문법 검사 기능 추가.</li>
                                        <li>교열 서비스의 품질 향상.</li>
                                        <li>웹사이트에 문법 문제가 없는지 확인.</li>
                                        <li>영어 학습자를 위한 피드백 제공.</li>
                                        <li>번역된 텍스트의 문법 오류 확인.</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="QuestionTwo">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                    aria-controls="QuestionTwoContent">
                                    내 텍스트 편집기에 실시간 검사를 통합할 수 있나요?</a>
                            </div>

                            <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                <div class="card-body">
                                    <p>텍스터 편집기에 실시간 검사를 통합하는 것은 일반적인 사용 사례입니다. 문법 검사는 글을 쓸 때마다 당연하게 기대하는 기능이 되었습니다. 트링카 문법 검사기는 모든 온라인 편집기에 쉽게 통합할 수 있습니다. 트링카는 이 작업을 쉽게 만들어 주는 문법 검사 구성 요소를 구축했습니다. 따라서 편집기에 문법 및 맞춤법 검사를 통합하는 데 몇 분밖에 걸리지 않을 것입니다. 또한 회사 스타일에 맞도록 구성 요소 모양을 맞춤 설정하기도 쉽습니다. 키보드 단축키와 그 밖의 맞춤 설정을 추가할 수도 있습니다.</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFour">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    무료 평가판이 있나요?
                                </a>
                            </div>

                            <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                <div class="card-body">
                                    <p>예, API를 무료로 사용해 볼 수 있습니다. <a data-toggle="modal" data-target="#EnterPriseContactPopup">문의하기</a></p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFive">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    API 문서를 사용할 수 있나요?
                                </a>
                            </div>

                            <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                <div class="card-body">
                                    <p>그렇습니다! 트링카 API를 통합에 도움이 되는 상세한 문서 및 통합 지원을 제공해 드립니다.  <a data-toggle="modal" data-target="#EnterPriseContactPopup">문의하기</a></p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionSix">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    문법 검사기 API를 사용한 작업을 시작하려면 추가로 드는 비용이 있나요?
                                </a>
                            </div>

                            <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                <div class="card-body">
                                    <p>아니요, 어떤 종류의 설치 비용도 없습니다. <a data-toggle="modal" data-target="#EnterPriseContactPopup">문의하기</a></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>
</div>

<div class="modal custom_modal_popup enterprisePopup sampleCode" id="sampleCode">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body">
                <div class="code-block">
                    <div class="closed_icons">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="row no-margin">
                        <div class="col-sm-6 no-gutter">
                            <h3 class="code-title">샘플 코드:</h3>
                            <div class="code-bloc">
                            <pre class="html ">
                                <div class="style-4 code">
1 curl --location --request POST
2 <span class="tx-green">'https://check.trinka.ai/languagecheck/v1/check' \</span>
3 --header 'x-api-key: xxxxzxzxzxzxzxzxzxzxz \
4 --header 'Content-Type: application/json' \
5
6 --data-raw '<span class="tx-yellow">&#123;</span>
7 <span class="tx-l-blue">"paragraph"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment.         
<span class="tx-white">8</span>    It is utilized as not only a structural component 
<span class="tx-white">9</span>    but also an interior finishing material that can be directly 
<span class="tx-white">10</span>    seen and touched in different buildings, such as houses, 
<span class="tx-white">11</span>    offices, and public facilities. Moreover, it brings a 
<span class="tx-white">12</span>    positive impression, such as comfort and relaxation, 
<span class="tx-white">13</span>    among residents and users."</span>,
14 <span class="tx-l-blue">"language"</span>: <span class="tx-orange">"US"</span>
15 <span class="tx-yellow">&#125;</span>'
                                </div>
                            </pre>
                            </div>
                        </div>
                        <div class="col-sm-6 no-gutter">
                            <h3 class="code-title">응답 샘플:</h3>
                            <div class="code-bloc">
                            <pre class="html style-4">
                                <div class="style-4 code ">
1 <span class="tx-yellow">&#123;</span>
2    <span class="tx-l-blue">"status"</span>: <span class="tx-d-blue">true</span>,
3   <span class="tx-l-blue">"input_para"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment. It is utilized as not only a structural component but also an interior finishing material that can be directly seen and touched in different buildings, such as houses, offices, and public facilities. Moreover, it brings a positive impression, such as comfort and relaxation, among residents and users."</span>,
4    <span class="tx-l-blue">"sentences"</span>: <span class="tx-pink">&#91;</span>
5        <span class="tx-d-blue">&#123;</span>
6            <span class="tx-green">/*** Input sentence and the offsets for the sentence ***/</span>
7            <span class="tx-l-blue">"sentence"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment."</span>,
8           <span class="tx-l-blue">"begin"</span> <span class="tx-l-green">0</span>,
9            <span class="tx-l-blue">"end"</span>: <span class="tx-l-green">54</span>,
10            <span class="tx-l-blue">"result"</span>: <span class="tx-yellow">&#91;</span>
11                <span class="tx-pink">&#123;</span>
12                   <span class="tx-green">/*** Detected issue and its details ***/</span>
13                    <span class="tx-l-blue">"start_index"</span>: <span class="tx-l-green">35</span>,
14                    <span class="tx-l-blue">"end_index"</span>: <span class="tx-l-green">40</span>,
15                    <span class="tx-l-blue">"covered_text"</span>: <span class="tx-orange">"indoor"</span>,
16                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
17                        <span class="tx-orange">"the indoor"</span>
18                    <span class="tx-d-blue">&#93;</span>,
19                    <span class="tx-green">/***  Suggestion for replacement or a comment ***/</span>
20                    <span class="tx-l-blue">"comment"</span>: <span class="tx-d-blue">&#91;</span>
21                        <span class="tx-orange">"Insert 'a', 'an', or 'the' before 'indoor'."</span>
22                    <span class="tx-d-blue">&#93;</span>,
23                    <span class="tx-green">/*** Error categorization ***/</span>
24                    <span class="tx-l-blue">"error_category"</span>: <span class="tx-d-blue">&#91;</span>
25                        <span class="tx-orange">"Grammar-Article"</span>
26                    <span class="tx-d-blue">&#93;</span>,
27                    <span class="tx-green">/*** Replacement text for the detected error ***/</span>
28                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
29                        <span class="tx-d-blue">true</span>
30                    <span class="tx-d-blue">&#93;</span>,
31                <span class="tx-pink">&#125;</span>
32            <span class="tx-yellow">&#93;</span>
33        <span class="tx-d-blue">&#125;</span>,
34        <span class="tx-d-blue">&#123;</span>
35            <span class="tx-green">/*** Input sentence and the offsets for the sentence ***/</span>
36            <span class="tx-l-blue">"sentence"</span>: <span class="tx-orange">"It is utilized as not only a structural component but also an interior finishing material that can be directly seen and touched in different buildings, such as houses, offices, and public facilities."</span>,
37            <span class="tx-l-blue">"begin"</span> <span class="tx-l-green">55</span>,
38            <span class="tx-l-blue">"end"</span>: <span class="tx-l-green">254</span>,
39            <span class="tx-l-blue">"result"</span>: <span class="tx-yellow">&#91;</span>
40                <span class="tx-pink">&#123;</span>
41                    <span class="tx-green">/*** Detected issue and its details ***/</span>
42                    <span class="tx-l-blue">"start_index"</span>: <span class="tx-l-green">6</span>,
43                    <span class="tx-l-blue">"end_index"</span>: <span class="tx-l-green">13</span>,
44                    <span class="tx-l-blue">"covered_text"</span>: <span class="tx-orange">"utilized"</span>,
45                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
46                        <span class="tx-orange">"used"</span>
47                    <span class="tx-d-blue">&#93;</span>,
48                    <span class="tx-green">/***  Suggestion for replacement or a comment ***/</span>
49                    <span class="tx-l-blue">"comment"</span>: <span class="tx-d-blue">&#91;</span>
50                        <span class="tx-orange">"Plain language tip: Replace \"utilized\" with \"used\" if it fits the context."</span>
51                    <span class="tx-d-blue">&#93;</span>,
52                    <span class="tx-green">/*** Error categorization ***/</span>
53                    <span class="tx-l-blue">"error_category"</span>: <span class="tx-d-blue">&#91;</span>
54                        <span class="tx-orange">"Enhancement"</span>
55                    <span class="tx-d-blue">&#93;</span>,
56                    <span class="tx-green">/*** Replacement text for the detected error ***/</span>
57                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
58                        <span class="tx-d-blue">true</span>
59                    <span class="tx-d-blue">&#93;</span>,
60                <span class="tx-pink">&#125;</span>
61            <span class="tx-yellow">&#93;</span>
62        <span class="tx-d-blue">&#125;</span>,
63    <span class="tx-pink">&#93;</span>,
64    <span class="tx-l-blue">"message"</span>: <span class="tx-orange">"Success"</span>
65 <span class="tx-yellow">&#125;</span> 
                                </div>
                            </pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-enterprise-modal></app-enterprise-modal>